module.exports = __webpack_public_path__ + "img/Rohani.029e5a29.jpg";